export default __webpack_public_path__ + "static/O0271-d0d9e74a372700c71bb399a9e5c38c6c.png";